import { Component, Prop, Vue} from "vue-property-decorator";
import { BuildingOutdoorWallSectionModuleModel, ConfiguratorValueUpdateModel, OutdoorWallModel, BuildingWallSection, WallOpening, Constants } from "../models";

import { productConfiguratorStore as store} from "./../store";
import HtmlElementHelper from "@/services/HtmlElementHelper";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import {  min_value, between } from "vee-validate/dist/rules";
import Cookie from "@/services/Cookie";

extend("min_value", {
    ...min_value,
    message: store.translations.belowAllowedLimitMessage
});

extend("between", {
    ...between,
    // message: store.translations.notWithinValidIntervalMessage
});

extend("opening_width_between", {
    ...between,
    message: store.translations.invalidBuildingWallOpeningMessage
});

@Component(
    {
        components: {
            ValidationProvider,
            ValidationObserver
          }
    }
)
export default class BuildingOutdoorWallSectionModule extends Vue {

    @Prop()
    protected vm!: BuildingOutdoorWallSectionModuleModel;
    protected selectedCustomConfiguratorProductCookie: string = "";

    protected outdoorWallModel: OutdoorWallModel = {
        wallSections: [
            {
                showOpenings: false,
                gableEnd: 0,
                wallOpenings: Array<WallOpening>()
            } as BuildingWallSection
        ]} as OutdoorWallModel;

    protected validationObs!: InstanceType<typeof ValidationObserver>;

    protected created() {
        if (!this.outdoorWallModel.wallSections.length) {
            this.addSection();
        }
        this.getCookie();
    }

    protected getCookie() {
        this.selectedCustomConfiguratorProductCookie = Cookie.getCookie("SelectedCustomConfiguratorProducts-" + this.vm.configuratorType);
        Cookie.applyCustomCookies(this.vm, this.selectedCustomConfiguratorProductCookie, this.outdoorWallModel);
        if (this.selectedCustomConfiguratorProductCookie !== "") {
            this.tryUpdateConfiguratorValue(true);
        }
    }

    protected mounted() {
        this.validationObs = this.$refs.validationObs as InstanceType<typeof ValidationObserver>;
    }

    protected addSection() {
        this.outdoorWallModel.wallSections.push({showOpenings: false, gableEnd: 0, wallOpenings: Array<WallOpening>()} as BuildingWallSection);
    }

    protected toggleOpeningSection(section: BuildingWallSection) {
        section.showOpenings = !section.showOpenings;

        if (section.showOpenings && !section.wallOpenings.length) {
            this.addOpening(section);
        }
    }

    protected showOpeningSection(section: BuildingWallSection) {
        return section.showOpenings;
    }

    protected addOpening(section: BuildingWallSection) {
        section.wallOpenings.push({ quantity: 1, beam: true} as WallOpening);
    }

    protected deleteSection(sectionIndex: number) {
        const tempSections = this.outdoorWallModel.wallSections;
        tempSections.splice(sectionIndex, 1);
        this.outdoorWallModel.wallSections = tempSections;
        if (!this.outdoorWallModel.wallSections.length) {
            this.addSection();
        }
        this.tryUpdateConfiguratorValue();
    }

    protected deleteOpening(openingIndex: number, section: BuildingWallSection) {
        section.wallOpenings.splice(openingIndex, 1);
        this.tryUpdateConfiguratorValue();
    }

    protected getOpeningMaxWidth(section: BuildingWallSection): number {
        return section.length;
    }

    protected getOpeningMaxHeight(section: BuildingWallSection, opening: WallOpening): number {
        let requiredLoadBearingProductHeight = 0;
        if (opening.beam) {
            requiredLoadBearingProductHeight += Constants.WallOpeningBeamHeightMetre;
            return section.height - requiredLoadBearingProductHeight;
        } else {
            return section.height - requiredLoadBearingProductHeight;
        }
    }

    protected getOpeningBeamMaxWidth(opening: WallOpening): number {
        return opening.beam ? Constants.outdoorWallMaxOpeningWidthMetre : 9999;
    }

    protected beamChanged() {
        this.tryUpdateConfiguratorValue();
    }

    protected tryUpdateConfiguratorValue(isFromCookie: boolean = false) {
        if (isFromCookie) {
            this.updateConfiguratorValue();
        } else {
            this.validationObs.validate().then(success => {
                if (success) {
                    if (this.outdoorWallModel.wallSections
                        .every(s => s.height > 0
                            && s.length > 0
                            && (!s.wallOpenings.length || s.wallOpenings.every(wo => wo.width > 0 && wo.height > 0 && wo.quantity > 0)))) {
                        this.updateConfiguratorValue();
                   }
                }
            });
        }
    }

    protected handleInputDebounce(inputValue: any, event: Event) {
        if (HtmlElementHelper.isEventTargetFocusedElement(event.target)) {
            this.tryUpdateConfiguratorValue();
        }
    }

    private updateConfiguratorValue() {
        const valueDescriptions = this.outdoorWallModel.wallSections
        .map(section => {
            const gableEndData = this.vm.hideGableInput ? `` : `, ${ this.translations.gableEnd}: ${section.gableEnd ? section.gableEnd : 0 } m`;
            return ({
            title: section.name ? section.name : this.translations.unnamedBuildingWallSection,
            text: `\n${ store.translations.commonLength}: ${ section.length} m, ${ this.translations.commonHeight}: ${section.height} m${gableEndData} ${ section.wallOpenings
                .map(opening => `\n${opening.name ? opening.name : this.translations.unnamedBuildingWallOpening}: ${opening.quantity} ${this.translations.commonPiecesAbbreviation} (${opening.width}x${opening.height} m) ${opening.beam ? this.translations.beam : ""} `).join("") }\n\n`
            });
        });

        valueDescriptions.unshift({ title: "", text: "\n"});

        const updateModel: ConfiguratorValueUpdateModel = { moduleId: this.vm.id, value: this.outdoorWallModel, valueDescriptions,
            propertyName: this.vm.configuratorProperties[0].propertyName, isText: false, resetClimateSavingsCookie: false };
        this.$emit("update-configurator-value", updateModel, true);
    }

    get translations() {
        return store.translations;
    }
}
